import * as React from "react";

const KotlinIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="72"
    height="72"
    viewBox="0 0 24 24"
  >
    <defs>
      <linearGradient
        id="SVGXvRYle2j"
        x1="1.725"
        x2="22.185"
        y1="22.67"
        y2="1.982"
        gradientTransform="translate(1.306 1.129)scale(.89324)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#7c4dff"></stop>
        <stop offset="0.5" stopColor="#d500f9"></stop>
        <stop offset="1" stopColor="#ef5350"></stop>
      </linearGradient>
    </defs>
    <path
      fill="url(#SVGXvRYle2j)"
      d="M2.975 2.976v18.048h18.05v-.03l-4.478-4.511-4.48-4.515 4.48-4.515 4.443-4.477z"
    ></path>
  </svg>
);

export default KotlinIcon;
